export default __webpack_public_path__ + "media/images/mailer/icon_email-0254abeeaa2c5d5f7642589cd048da38.png";